import { useState } from "react";
import { CButton, CCard, CCardBody, CCardText, CCardTitle, CCol, CCollapse, CFormCheck, CFormTextarea, CListGroup, CListGroupItem, CRow, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from '@coreui/react';
import '../styles/PendingRequests.css';

const timeOffNames = {
    "TOVAC": "Vacation",
    "TOPER": "Personal Leave (Paid)",
    "TOSIC": "Sick Leave (Paid)",
    "TOBER": "Bereavement (Paid)",
    "TOUNP": "Time Off (Unpaid)",
    "VACPAYOUT": "Vacation Payout"
}

export default function ManagerPending({ requests, onSubmit, loading, open, setOpen }) {

    const [status, setStatus] = useState(null);
    const [commentsToDriver, setCommentsToDriver] = useState("");
    const [commentsToTMW, setCommentsToTMW] = useState("");
    const [error, setError] = useState(null);

    function handleOpen(i) {
        setError(null);
        setStatus(null);
        setCommentsToDriver("");
        setCommentsToTMW(requests[i].commentsToTMW || "");
        if (i === open) {
            setOpen(-1);
        } else {
            setOpen(i);
        }
    }

    function daysSince(d) {
        var today = new Date()
        today.setHours(0, 0, 0, 0)
        var date = new Date(d)
        date.setHours(0, 0, 0, 0)

        return Math.floor((today - date) / (1000 * 60 * 60 * 24))
    }

    return (
        <CCard>
            <CCardBody>

                <>
                    <CCardTitle className='fs-2'>All Pending Requests</CCardTitle>
                    <hr />
                    <CListGroup>

                        {requests.length > 0 ? requests.map((req, i) => {
                            const isThresholdExceeded = !!req.isThresholdExceeded;

                            return (
                                <div key={i}>
                                    <CListGroupItem
                                        style={{
                                            cursor: 'pointer',
                                            // highlight threshold exceeded requests
                                            borderLeft: isThresholdExceeded ? '6px solid #dc3545' : undefined,
                                            backgroundColor: isThresholdExceeded ? '#fff5f5' : undefined,
                                        }}
                                        component="a"
                                        active={open === i}
                                        onClick={() => { handleOpen(i); }}
                                    >
                                        <div className="d-flex w-100 justify-content-between">
                                            <h5 className="mb-1">
                                                {req.employeeName}
                                                {isThresholdExceeded && (
                                                    <span style={{ marginLeft: '8px', fontSize: '0.85rem', color: '#dc3545' }}>
                                                        (Threshold exceeded)
                                                    </span>
                                                )}
                                            </h5>
                                            <small className="text-medium-emphasis">
                                                {daysSince(req.createdAt) > 0
                                                    ? `${daysSince(req.createdAt)} day(s) ago`
                                                    : "Today"}{" "}
                                            </small>
                                        </div>
                                        <CTable responsive id="pending">
                                            <CTableHead>
                                                <CTableRow>
                                                    <CTableHeaderCell scope="col" align='center'>Type</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col" align='center'>Start Date</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col" align='center'>End Date</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col" align='center'>Duration</CTableHeaderCell>
                                                    <CTableHeaderCell scope="col" align='center'>Status</CTableHeaderCell>
                                                </CTableRow>
                                            </CTableHead>
                                            <CTableBody>
                                                <CTableRow>
                                                    <CTableDataCell>{timeOffNames[req.timeOffType]}</CTableDataCell>
                                                    <CTableDataCell>{parseFloat(req.duration) > 0.5 ? req.startDate.split("T")[0] : req.startDate}</CTableDataCell>
                                                    <CTableDataCell>{parseFloat(req.duration) > 0.5 ? req.endDate.split("T")[0] : req.endDate}</CTableDataCell>
                                                    <CTableDataCell>{parseFloat(req.duration)} Day(s)</CTableDataCell>
                                                    <CTableDataCell>{req.timeOffStatus}</CTableDataCell>
                                                </CTableRow>
                                            </CTableBody>
                                        </CTable>
                                    </CListGroupItem>

                                    <CCollapse visible={open === i}>
                                        <CCard className="m-3" style={{ border: 'none' }}>
                                            <CCardBody>
                                                {isThresholdExceeded && (
                                                    <CCardText className='fs-5' style={{ color: '#dc3545', fontWeight: 600 }}>
                                                        Threshold exceeded for this request. Only the Terminal Manager can approve.
                                                        {req.thresholdDetails && (
                                                            <>
                                                                <br />
                                                                <span style={{ fontSize: '0.9rem' }}>{req.thresholdDetails}</span>
                                                            </>
                                                        )}
                                                    </CCardText>
                                                )}
                                                {/* Comments */}
                                                <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Comments to Driver (optional)</CCardText>
                                                <CFormTextarea className='fs-4' placeholder='Comments' value={commentsToDriver} onChange={(e) => { if (e.target.value.length <= 200) { setCommentsToDriver(e.target.value) } }} />
                                                {req.timeOffStatus === 'Pending Approval' ?
                                                    <>
                                                        <CCardText className='fs-4' style={{ marginBottom: '8px', marginTop: '8px' }}>Comments to TMW (optional)</CCardText>
                                                        <CFormTextarea className='fs-4' placeholder='Comments' value={commentsToTMW} onChange={(e) => { if (e.target.value.length <= 200) { setCommentsToTMW(e.target.value) } }} />
                                                    </> : null}
                                                {/* Accept/Reject */}
                                                <CRow>
                                                    <CCol style={{ display: 'flex', justifyContent: 'left' }} >
                                                        <CFormCheck readOnly button={{ color: 'success', variant: 'outline' }} type="radio" name={"options-outlined" + i} id={"success-outlined" + i} autoComplete="off" label="Approve" checked={status === 'approve'} onChange={(e) => { setStatus("approve") }} />
                                                        <CFormCheck readOnly button={{ color: 'danger', variant: 'outline' }} type="radio" name={"options-outlined" + i} id={"danger-outlined" + i} autoComplete="off" label="Reject" checked={status === 'reject'} onChange={(e) => { setStatus("reject") }} />
                                                    </CCol>
                                                    <CCol style={{ display: 'flex', justifyContent: 'right' }}>
                                                        <CButton onClick={() => { onSubmit(i, status, commentsToDriver, commentsToTMW) }} className='my-2' disabled={loading}>Submit</CButton>
                                                    </CCol>
                                                </CRow>

                                                {error ? <CCardText style={{ color: 'red', fontWeight: '600', fontSize: '20px', display: "flex", justifyContent: 'end' }}>{error}</CCardText> : null}
                                            </CCardBody>
                                        </CCard>
                                    </CCollapse>
                                </div>
                            )
                        }) : <CCardText>No Pending Requests</CCardText>}
                    </CListGroup>
                </>
            </CCardBody>
        </CCard>
    )
}

